import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerResponse } from '../models/types';
import { Voucher, ListVoucher } from '../models/payment.model';

@Injectable()
export class VoucherService {
    url = '';
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') baseUrl: string
    ) {
        this.url = baseUrl;
    }

  async getVoucher(mach: string, 
    maHTTT: string, maQuay: string,
    MaNV: string, STTHD: number,
    hdID: string, voucherCode: string) {
    return this.http.post(this.url + 'api/ScannerQR/callAPI_ScanCode', {
      QR_ID: voucherCode,
      maCH: mach,
      amount: 0,
      maHTTT: maHTTT,
      maQuay: maQuay,
      MaNV: MaNV,
      STTHD: STTHD,
      hdID: hdID
    }).toPromise()
        .then((result: ServerResponse) => {
            if (result.code === 1) {
                return Promise.resolve(result.data);
            } else {
                return Promise.reject(result.message);
            }
        });
    }


    async updateVoucher(value: Voucher, MaQuay, hdID, MaKHTV, STTHD, MaHDSD) {
      return this.http.post(this.url + 'api/HoaDon/updateVoucher', {
          MaPhieu: value.MaPhieu,
          MaQuay: MaQuay,
          HoaDonID: hdID,
          MaKHTV: MaKHTV,
          STTHD: STTHD,
          MaHDSuDung: MaHDSD
        })
        .toPromise()
        .then((result: ServerResponse) => {
            if (result.code === 1) {
                return Promise.resolve(result.message);
            } else {
                return Promise.reject(result.message);
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/services/voucher.service.ts